import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PageLinks from '../components/PageLinks';
import Brand from '../components/Brand';
import Footer from '../components/Footer';

class About extends Component {
  
  render() {
    return(
      <div class="public pricing">
        <header className="App-header">
          <Brand />
          <PageLinks />
          <ul className="account">
            <Link className="btn" to="/signup">Get Started</Link>
          </ul>
        </header>
        <div class="hero">
          <div class="content">
            <h1>Tech For The Rest</h1>
            <br/>
            <h2>🗺🥗🥊🎤🧶💈🖋🧰🌊👠🎭🚜</h2>
            <br/>
            <h4>
              We're putting technology in the hands of the 99%. You know, the majority of folks that don't know any vim keyboard shortcut 💾. They don't even know what HTML stands for 😱🤯. That person that spends their time painting 👨🏽‍🎨, welding 👩🏼‍🏭, training 👨🏿‍⚕️, or cooking 👩🏻‍🍳 instead of hunched over a computer.
            </h4>
            <br/>
            <h4>
              They're not experts at tech, they're experts at the many things that the world needs. They're bursting with creative ideas 💡, but face an insurmountable hurdle of not being tech experts to bring those ideas to life.
            </h4>
            <br/>
            <h4>
              By making it easier for them to create 🧩 tech without needing a computer science degree 📜, we're helping them impact the world 🌍  in ways that a bunch of programmers crowded in a tiny office can't possibly imagine.
            </h4>
            <br/>
            <h2>Help us create tech for the brands, businesses, and mom and pop shops of the future.</h2>


          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/About.js